export default __webpack_public_path__ + "static/media/expl_08_EN.1d14cece.png";